<div class="section-container">
  <div nz-row class="section-row">
    <div nz-col nzSpan="11" class="section-label">
      Registration Code Address
    </div>
    <div nz-col nzSpan="13">
      <span *ngIf="address?.rca" class="rca-badge">
        {{address?.rca}}
      </span>
    </div>
  </div>

  <div nz-row class="section-row">
    <div nz-col nzSpan="11" class="section-label">City</div>
    <div nz-col nzSpan="13">
      <span class="section-value">{{address?.city}}</span>
    </div>
  </div>

  <div nz-row class="section-row">
    <div nz-col nzSpan="11" class="section-label">District</div>
    <div nz-col nzSpan="13">
      <span class="section-value">{{address?.district}}</span>
    </div>
  </div>

  <div *ngIf="address?.street" nz-row class="section-row">
    <div nz-col nzSpan="11" class="section-label">Street</div>
    <div nz-col nzSpan="13">
      <span class="section-value">{{address?.street}}</span>
    </div>
  </div>

  <div nz-row class="section-row">
    <div nz-col nzSpan="11" class="section-label">Building number</div>
    <div nz-col nzSpan="13">
      <span class="section-value">{{address?.buildingNumber}}</span>
    </div>
  </div>

  <div nz-row class="section-row">
    <div nz-col nzSpan="11" class="section-label">Office/Room number</div>
    <div nz-col nzSpan="13" class="section-value">
      <span *ngIf="!address?.officeRoomNumber">Without an office/room number</span>
      <span *ngIf="address?.officeRoomNumber">{{address?.officeRoomNumber}}</span>
    </div>
  </div>

  <div nz-row class="section-row">
    <div nz-col nzSpan="11" class="section-label">Postal code</div>
    <div nz-col nzSpan="13">
      <span class="section-value">{{address?.postalCode}}</span>
    </div>
  </div>

  <div nz-row class="section-row" [class.no-border]="!hasLeasePeriod">
    <div nz-col nzSpan="11" class="section-label">Expiration date of office address</div>
    <div nz-col nzSpan="13" class="section-value">
      <span *ngIf="address?.expirationDate">{{address?.expirationDate | date: 'dd.MM.yyyy'}}</span>
      <span *ngIf="!address?.expirationDate">Unspecified</span>
    </div>
  </div>

  <ng-container *ngIf="hasLeasePeriod">
    <div nz-row class="section-row">
      <div nz-col nzSpan="11" class="section-label">Lease Start Date</div>
      <div nz-col nzSpan="13">
        <span class="section-value">{{address?.startDate | date: 'dd.MM.yyyy'}}</span>
      </div>
    </div>

    <div nz-row class="section-row no-border">
      <div nz-col nzSpan="11" class="section-label">Lease End Date</div>
      <div nz-col nzSpan="13">
        <span class="section-value">{{address?.endDate | date: 'dd.MM.yyyy'}}</span>
      </div>
    </div>
  </ng-container>
</div>
